module.exports = __webpack_public_path__ + "images/category_lp/common/crown-2_efdad4eec3dc31a9bf14fc1a415a699f.png";